module.exports = __webpack_public_path__ + "img/DEOK_karta_image-new-min.b45f5754.png";